import React from 'react';
import { Box } from '@mui/material';

/**
 * Full-height two-column workspace for the generator pages.
 *
 * The page itself never scrolls - the options column and the diagram each
 * manage their own overflow, so the diagram always gets the full remaining
 * viewport height instead of a hard-coded `calc(100vh - 200px)`.
 */
const WorkspaceLayout = ({ panel, children }) => (
  <Box
    sx={{
      flex: 1,
      height: '100%',
      minHeight: 0,
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      gap: 2,
      p: 2,
      overflow: { xs: 'auto', md: 'hidden' }
    }}
  >
    {panel}
    <Box sx={{ flex: 1, minWidth: 0, minHeight: { xs: 480, md: 0 }, display: 'flex' }}>
      {children}
    </Box>
  </Box>
);

export default WorkspaceLayout;
